import React from 'react'
import {PageWrap} from "../../Components";
import AnnualLeaveList from "../../Containers/Vacation/AnnualLeaveList";

const VacationAnnualPage = () => (
    <PageWrap>
        <h3>연차 현황</h3>
        <AnnualLeaveList/>
    </PageWrap>
)

export default VacationAnnualPage
